import React from 'react';
import { IconWrapper } from '@flexo/general';

interface DrawerCloseButtonProps {
  onClose: () => void;
  /** Accessible label for the button — callers should pass t('common.close') or similar */
  ariaLabel?: string;
}

/**
 * FLEXO-6089: Accessible close button for all right-drawer contents.
 *
 * Renders as a native <button> so it is:
 *  - reachable by Tab automatically
 *  - activated by Enter AND Space out of the box
 *  - announced by screen readers with an aria-label
 *
 * Drop-in replacement for the old `<div onClick={closeDrawer}><IconWrapper iconName="cross" /></div>`
 * pattern that was inaccessible (no role, no tabIndex, no label).
 */
export const DrawerCloseButton: React.FC<DrawerCloseButtonProps> = ({
  onClose,
  ariaLabel = 'Close',
}) => {
  return (
    <button
      type="button"
      onClick={onClose}
      aria-label={ariaLabel}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        margin: 0,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <IconWrapper iconName="cross" />
    </button>
  );
};

export default DrawerCloseButton;
